"use client";

import { useEffect } from "react";
import { BLOG_SEEN_COOKIE, BLOG_SEEN_MAX_AGE_SECONDS, nextSeen, seenFromCookieHeader } from "@/lib/blog/seen";

/**
 * Records that this post was opened, for the new-post mark on Blog in the
 * menu (lib/blog/seen.ts). Renders nothing. Written from the page rather than
 * the server because a server component cannot set a cookie, and only moved
 * forward: an older post read later leaves a newer date in place.
 */
export function BlogSeen({ date }: { date: string }) {
  useEffect(() => {
    const seen = seenFromCookieHeader(document.cookie);
    const next = nextSeen(seen, date);
    if (next === seen) return;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${BLOG_SEEN_COOKIE}=${next}; path=/; max-age=${BLOG_SEEN_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
  }, [date]);
  return null;
}
